/**
 * @file 中断処理を実装する
 */

export function wait(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms))
}

